var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "card", staticStyle: { "min-height": "300px" } },
    [
      _c("div", { staticClass: "card-header" }, [
        _vm._v(" Productions du jour ")
      ]),
      _c("div", { staticClass: "card-container" }, [
        !_vm.gotProductions
          ? _c(
              "div",
              { staticStyle: { "text-align": "center", "margin-top": "50px" } },
              [
                _c("img", {
                  staticStyle: { height: "100px", "margin-left": "-8px" },
                  attrs: {
                    alt: "en attente",
                    src: "/assets/images/spinners/cooking-blue-court.gif"
                  }
                })
              ]
            )
          : _c("div", [
              _c("h2", { staticClass: "text-center mt-2" }, [
                _c("b", [_vm._v(_vm._s(_vm.nombreProductions))])
              ]),
              _c("div", { staticClass: "text-center" }, [
                _c("b", [
                  _vm._v(
                    "production" +
                      _vm._s(_vm.productions.length > 1 ? "s" : "") +
                      " prévue" +
                      _vm._s(_vm.productions.length > 1 ? "s" : "")
                  )
                ])
              ]),
              _vm._m(0),
              _c(
                "div",
                {
                  staticClass:
                    "card card-minimal table-scroll height-responsive-inner-bottom-50 mt-4"
                },
                [
                  _vm._m(1),
                  _c("hr", { staticClass: "mt-0 mb-0" }),
                  _c("div", { staticClass: "table-body" }, [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-sm table-borderless text-center"
                      },
                      [
                        _vm._m(2),
                        _c(
                          "tbody",
                          [
                            _vm.productions.some(function(l) {
                              return (
                                _vm.formatDateAvecTirets(l.dateProduction) ===
                                _vm.formatDateAvecTirets(new Date())
                              )
                            })
                              ? _c("tr", [
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.formatHumanDate(new Date()))
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._l(
                              _vm.productions.filter(function(l) {
                                return (
                                  _vm.formatDateAvecTirets(l.dateProduction) ===
                                  _vm.formatDateAvecTirets(new Date())
                                )
                              }),
                              function(production, iProduction) {
                                return _c("tr", { key: iProduction }, [
                                  _c("td", [_vm._v(_vm._s(production.nom))]),
                                  _c(
                                    "td",
                                    { staticClass: "p-1" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            title:
                                              "Télécharger la fiche de production"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.telechargerFichesProd(
                                                production.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Voir")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            title:
                                              "Télécharger la fiche de sortie"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.telechargerFichesSortie(
                                                production.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Voir")]
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "td",
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            title:
                                              "Télécharger le bon de livraison"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.telechargerBonDeLivraison(
                                                production.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Voir")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              }
                            ),
                            _vm.productions.some(function(l) {
                              return (
                                _vm.formatDateAvecTirets(l.dateProduction) ===
                                _vm.formatDateAvecTirets(_vm.demain())
                              )
                            })
                              ? _c("tr", [
                                  _c("td", { attrs: { colspan: "4" } }, [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatHumanDate(_vm.demain())
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _vm._l(
                              _vm.productions.filter(function(l) {
                                return (
                                  _vm.formatDateAvecTirets(l.dateProduction) ===
                                  _vm.formatDateAvecTirets(_vm.demain())
                                )
                              }),
                              function(production, iProduction) {
                                return _c(
                                  "tr",
                                  { key: "demain" + iProduction },
                                  [
                                    _c("td", [_vm._v(_vm._s(production.nom))]),
                                    _c(
                                      "td",
                                      { staticClass: "p-1" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: {
                                              title:
                                                "Télécharger la fiche de production"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.telechargerFichesProd(
                                                  production.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Voir")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: {
                                              title:
                                                "Télécharger la fiche de sortie"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.telechargerFichesSortie(
                                                  production.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Voir")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "btn btn-primary",
                                            attrs: {
                                              title:
                                                "Télécharger le bon de livraison"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.telechargerBonDeLivraison(
                                                  production.id
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("Voir")]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              }
                            )
                          ],
                          2
                        )
                      ]
                    )
                  ])
                ]
              ),
              _c(
                "div",
                { staticClass: "text-center mt-2 mb-2" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { disabled: !_vm.profilIsUtilisateur },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: "SuiviProduction",
                            params: { etablissementId: _vm.etabCourantId }
                          })
                        }
                      }
                    },
                    [_vm._v("Voir plus de détails")]
                  )
                ],
                1
              )
            ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("b", [_vm._v("entre aujourd'hui et demain")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      { staticClass: "table table-sm table-borderless text-center" },
      [
        _c("colgroup", [
          _c("col"),
          _c("col", { attrs: { width: "130" } }),
          _c("col", { attrs: { width: "130" } }),
          _c("col", { attrs: { width: "130" } })
        ]),
        _c("thead", [
          _c("th", [_vm._v("Productions")]),
          _c("th", [_vm._v("Fiche de prod")]),
          _c("th", [_vm._v("Fiche de sortie")]),
          _c("th", [_vm._v("Bon de livraison")])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { attrs: { width: "130" } }),
      _c("col", { attrs: { width: "130" } }),
      _c("col", { attrs: { width: "125" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }